export default __webpack_public_path__ + "static/media/work-watch.60007f50.png";